import { render, staticRenderFns } from "./SliderNavBtns.vue?vue&type=template&id=37d713b2&scoped=true&"
import script from "./SliderNavBtns.vue?vue&type=script&lang=ts&"
export * from "./SliderNavBtns.vue?vue&type=script&lang=ts&"
import style0 from "./SliderNavBtns.vue?vue&type=style&index=0&id=37d713b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d713b2",
  null
  
)

export default component.exports